import { ShieldCheck } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const VAWAPetitions = () => {
  const faqs = [
    {
      question: "What evidence do I need for VAWA?",
      answer: "Evidence includes proof of qualifying relationship (marriage certificate, birth certificate), proof of abuser's status, evidence of abuse (police reports, medical records, protective orders, photos, witness statements), and good moral character evidence. We help gather and present this sensitive evidence carefully.",
    },
    {
      question: "Will my abuser know I filed?",
      answer: "No. VAWA petitions are confidential. USCIS will not notify your abuser or share information with them. This protection allows you to seek immigration relief safely without fear of retaliation.",
    },
  ];

  const mainContent = (
    <>
      <div className="prose prose-lg max-w-none mb-12">
        <h2 className="text-3xl font-bold mb-6">Immigration Relief for Abuse Survivors</h2>
        <p className="text-xl text-muted-foreground mb-8">
          The Violence Against Women Act (VAWA) allows certain abused spouses, children, and parents to self-petition for lawful permanent residence without the abuser's knowledge or consent. This protection is gender-neutral and available to all abuse survivors.
        </p>

        <h3 className="text-2xl font-bold mb-4">Who Qualifies for VAWA?</h3>
        <ul className="list-disc pl-6 mb-6">
          <li>Abused spouses of U.S. citizens or LPRs</li>
          <li>Abused children (under 21) of U.S. citizens or LPRs</li>
          <li>Abused parents of U.S. citizen children (21 or older)</li>
          <li>Individuals whose petitions were denied due to abuse or domestic violence</li>
        </ul>

        <h3 className="text-2xl font-bold mb-4">Benefits of VAWA</h3>
        <ul className="list-disc pl-6 mb-8">
          <li>Self-petition without abuser's involvement</li>
          <li>Protection from deportation</li>
          <li>Work authorization eligibility</li>
          <li>Path to lawful permanent residence</li>
          <li>Public benefits access</li>
        </ul>
        <p className="mb-8">
          VAWA petitions are confidential and won't alert the abuser.
        </p>

        <h3 className="text-2xl font-bold mb-6">Frequently Asked Questions</h3>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left">{faq.question}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{faq.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </>
  );

  return (
    <GenericPracticePage
      title="VAWA Petitions"
      subtitle="Self-petitions for abused spouses, children, and parents of U.S. citizens/residents"
      icon={<ShieldCheck className="h-20 w-20 mx-auto mb-6 text-accent" />}
      mainContent={mainContent}
    />
  );
};

export default VAWAPetitions;
